import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {InteractionsService} from 'src/app/services/interactions.service';
import {MethodsService} from 'src/app/services/methods.service';

@Component({
  selector: 'app-quiz',
  templateUrl: './quiz.component.html',
  styleUrls: ['./quiz.component.scss']
})
export class QuizComponent implements OnInit, OnDestroy {

  @Input('interactionId') interactionId;

  public interaction;
  public borderRisposta = 'grey';
  private interactionsSubscriber;
  public language;

  constructor(
    private interactionsService: InteractionsService,
    private methods: MethodsService
  ) {
    this.language = localStorage.getItem('l');
  }

  ngOnInit(): void {
    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/'+this.language +'/' + this.interaction.content.configId + '.config.json')
        .subscribe(config => {
          this.interaction.config = config;
        });
    });
  }

  isCorrect(risposta) {
    if (!this.interaction.completed.onComplete) {
      risposta.selected = true;
      if (risposta.value) {
        this.interaction.completed = {
          onComplete: true,
          status: 'success'
        };
        this.interactionsService.setCompleted(this.interaction);
        this.interactionsService.updateInteraction(this.interaction);
      } else {
        this.interaction.completed = {
          onComplete: true,
          status: 'failed'
        };
      }
    }
  }

  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }

}
